import { getAssessmentSummaryQuery } from 'chameleon-src/queries';

const getAssessmentSummary = async (client, itemId, groupId) => {
  const response = await client.query({
    query: getAssessmentSummaryQuery,
    fetchPolicy: 'network-only',
    variables: {
      itemId,
      groupId,
    },
  });
  return response && response.data;
};

export default getAssessmentSummary;
